import { Controller } from "stimulus"

// Afficher / masquer un mot de passe.
//
//   <div data-controller="password">
//     <input type="password" data-password-target="input">
//     <button type="button" data-action="password#toggle" data-password-target="button">
//       <i class="uil uil-eye" data-password-target="icon"></i>
//     </button>
//   </div>
//
// Un controleur par champ : le champ « confirmation » a son propre bouton.
export default class extends Controller {
  static targets = ["input", "button", "icon"]

  connect() {
    this.render()
  }

  // Le cache de Turbolinks restaure la page telle quelle : on ne laisse jamais
  // un mot de passe en clair dans une page mise en cache.
  disconnect() {
    if (this.hasInputTarget) this.inputTarget.type = "password"
  }

  toggle(event) {
    event.preventDefault()

    const input = this.inputTarget
    const start = input.selectionStart
    const end = input.selectionEnd

    input.type = this.visible ? "password" : "text"
    this.render()

    // Garde le focus et la position du curseur : on continue a taper sans clic.
    input.focus()
    try { input.setSelectionRange(start, end) } catch (_error) { /* type sans selection */ }
  }

  get visible() {
    return this.inputTarget.type === "text"
  }

  render() {
    const visible = this.visible

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-pressed", visible ? "true" : "false")
      this.buttonTarget.setAttribute(
        "aria-label",
        visible ? "Masquer le mot de passe" : "Afficher le mot de passe"
      )
      this.buttonTarget.setAttribute(
        "title",
        visible ? "Masquer le mot de passe" : "Afficher le mot de passe"
      )
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("uil-eye", !visible)
      this.iconTarget.classList.toggle("uil-eye-slash", visible)
    }
  }
}
